import classNames from 'classnames';
import * as React from 'react';
import { MouseEventHandler } from 'react';

type HtmlButtonType = 'submit' | 'reset' | 'button';

export type ButtonSize = 'small' | 'medium' | 'large' | 'xlarge';
export type ButtonTier = 'primary' | 'secondary' | 'tertiary' | 'quaternary';
export type ButtonType = 'solid' | 'underline' | 'clear';

export interface DefaultButtonProps {
    children: React.ReactNode;
    onClick?: MouseEventHandler<HTMLButtonElement>;
    onFocus?: () => void;
    draggable?: boolean;
    disabled?: boolean;
    id?: string;
    className?: string;
    htmlType?: HtmlButtonType;
    size?: ButtonSize
    type?: ButtonType;
    tier?: ButtonTier;
}

type ButtonProps = DefaultButtonProps &
    Pick<
        React.ButtonHTMLAttributes<HTMLButtonElement>,
        | 'aria-selected'
        | 'aria-controls'
        | 'aria-expanded'
        | 'role'
        | 'aria-haspopup'
        | 'aria-describedby'
        | 'aria-label'
        | 'tabIndex'
        | 'onMouseEnter'
        | 'onMouseLeave'
        | 'onFocus'
        | 'onBlur'
    >;

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
    const {
        onClick,
        onFocus,
        draggable,
        disabled,
        id,
        className,
        htmlType = 'button',
        children,
        size,
        type,
        tier,
        ...otherProps
    } = props;

    const styleModifiers = {
        'insuranceButton--small': size == 'small',
        'insuranceButton--medium': size == 'medium',
        'insuranceButton--large': size == 'large',
        'insuranceButton--xlarge': size == 'xlarge',
        'insuranceButton--solid': type == 'solid',
        'insuranceButton--underline': type == 'underline',
        'insuranceButton--clear': type == 'clear',
        'insuranceButton--primary': tier == 'primary',
        'insuranceButton--secondary': tier == 'secondary',
        'insuranceButton--tertiary': tier == 'tertiary',
        'insuranceButton--quaternary': tier == 'quaternary',
    }

    return (
        <button
            {...otherProps}
            onClick={onClick}
            onFocus={onFocus}
            draggable={draggable}
            disabled={disabled}
            type={htmlType}
            id={id}
            ref={ref}
            className={classNames(
                'insuranceButton',
                className,
                styleModifiers
            )}
        >
            {children}
        </button>
    );
});
